/* eslint-disable no-underscore-dangle */

const _require = require('@truqc/content-path'),
  keysSortedByValueAscending = _require.keysSortedByValueAscending;

// const moment = require('moment-timezone');
const momentTimezone = require('moment-timezone');
const momentStandard = require('moment');
const moment = {
  utc: momentTimezone.utc || momentStandard.utc
};
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;

/**
  * @function evalute - evaluate titleComponentsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const components = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  const evaluatedTimeZone = await evaluateSource(source.timeZone, content, parentContentPath, transientContext, nativeFunctions);
  const titles = [];
  keysSortedByValueAscending(components).forEach(key => {
    const _components$key = components[key],
      text = _components$key.text,
      date = _components$key.date;
    if (text !== undefined) {
      titles.push(text);
    } else if (date !== undefined) {
      try {
        const dateTime = moment.utc(new Date(date));
        const zonedDateTime = evaluatedTimeZone === undefined ? dateTime.local() : dateTime.tz(evaluatedTimeZone);
        titles.push(zonedDateTime.format('MM/DD/YYYY, h:mm A'));
      } catch (e) {
        titles.push('undefined');
      }
    }
  });
  return titles.join(', ');
};
module.exports = {
  evaluate
};